import { render, staticRenderFns } from "./SMSInbox.vue?vue&type=template&id=2b077fda&"
import script from "./SMSInbox.vue?vue&type=script&lang=js&"
export * from "./SMSInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports